import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { LocalStorageService } from "../services/LocalStorage";
import { useEffect, useState } from "react";
import Loader from "../components/Loader/Loader";

const ProtectedRoute = ({ layout: Layout, component: Component, role, ...rest }) => {
    const { user, isUserLogin } = useSelector((state) => state.login);
    const [isLoading, setIsLoading] = useState(true);
    const userData = user || LocalStorageService.getItem("user");
    const urlParams = new URLSearchParams(window.location.search);
    const tokenParam = urlParams.get('token');
    const location = useLocation();
    const searchParams = location.search;

    useEffect(() => {
        if (tokenParam) {
            LocalStorageService.setItem('userToken', tokenParam);
        }
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 500);
        return () => clearTimeout(timer);
    }, [tokenParam, user]);

    const roleMap = {
        admin: ["ADMIN", "SUBADMIN"],
        user: ["CUSTOMER"],
        white_label: ["WHITE_LABEL"],
        mmp_admin: ["MMP_ADMIN"],
        admin_or_mmp_admin: ["ADMIN", "SUBADMIN", "MMP_ADMIN"]
    };

    const isAuthenticated = () => {
        const token = LocalStorageService.getItem('userToken');
        return isUserLogin || token;
    };

    if (isLoading) {
        return <Loader fullPage={true} tip="Please wait..." />;
    }

    if (!isAuthenticated()) {
        return <Navigate to="/login/admin" />;
    }

    if (tokenParam && !userData) {
        return <Loader fullPage={true} tip="Please wait..." />;
    }

    const hasRole = role ? roleMap[role]?.includes(userData?.role) : true;

    if (!hasRole) {
        if (role === "admin" && roleMap.admin.includes(userData?.role)) {
            if (!tokenParam) {
                return <Navigate to="/users" />;
            } else {
                return <Navigate to={`/dashboard?token=${tokenParam}`} />;
            }
        } else if (role === "user" && userData?.role === "CUSTOMER") {
            return <Navigate to="/dashboard" />;
        } else if (role === "white_label" && userData?.role === "WHITE_LABEL") {
            // Only redirect to /wl/users if not already on a white label route
            if (!location.pathname.startsWith('/wl/')) {
                return <Navigate to={`/wl/home${searchParams}`} />;
            }
        } else if (role === "mmp_admin" && userData?.role === "MMP_ADMIN") {
            return <Navigate to="/make-my-profit/home" />;
        }
        return <Navigate to="/login/admin" />;
    }

    return (
        <Layout>
            <Component {...rest} />
        </Layout>
    );
};
export default ProtectedRoute;